<template>
  <el-table-column
    prop="count"
    label="Mennyiség"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.count }} db
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'count',
  };
</script>
